import React from 'react';
import Axl from '../../utils/Axl';
import AppContext from '../../contexts/AppContext';
import './ArtworkBottomInfo.css';

const ArtworkBottomInfo = ({ selectedItem }) => {
  const { axl } = React.useContext(AppContext);

  const onClickLinkHandler = (url) => {
    axl.sendMessage(Axl.ChildToHost.NAVIGATE, url);
  };

  return (
    <div id="footer">
      <div id="artwork-title">
        <button
          type="button"
          className="btn-link"
          onClick={() => {
            onClickLinkHandler(`asset/${selectedItem.asset_id}`);
          }}
        >
          {selectedItem.title}
        </button>
        <p className="creator">
          <span>{selectedItem.creator}</span>
          <span>{selectedItem.collection_title || ''}</span>
        </p>
      </div>
      {selectedItem.partner_logo && (
        <div id="artwork-partner-logo">
          <img alt={selectedItem.creator} src={selectedItem.partner_logo} />
        </div>
      )}
    </div>
  );
};

export default ArtworkBottomInfo;
